import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom';

function CollectionTile(collection) {

    const [stats, setStats] = useState({});

    const getCollectionStats = async () => {
        axios
            .get("/api/v1/collections/stats/" + collection.id)
            .then((result) => setStats(result.data))
            .catch((err) => console.log(err));
    }
    useEffect(() => {
        getCollectionStats();
    }, []);


    return (
        <div>
            <div className="document-tile">
                <div className="document-tile-metadata">
                    <h4><Link to={"/DocumentList/" + collection.id}>{collection.name}</Link></h4>
                    <p>{collection.shortDescription}</p>
                    <br />
                </div>
                <div className="document-tile-stats">
                    <p>{stats.total} Total</p>
                    <p>{stats.newDocs} New</p>
                </div>
            </div>
            <hr />
        </div>
    )
}

export default CollectionTile
